import i18n from '@/plugins/i18n/config.ts'

const { t } = i18n.global

export default {
  /* Add input validators here */
  requiredRule: (value: string) => !!value?.trim() || t("validators.required"),
  emailRules: [
    (value: string) => !!value || t("validators.email.required"),
    (value: string) =>
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value) ||
      t("validators.email.invalid"),
  ],
};
